async function getVendors() {
 const res = await fetch("https://us-central1-masca-51862.cloudfunctions.net/api/shopify/vendors");
 
 const data = await res.json();

const userLat = parseFloat(localStorage.getItem('userLat'));
const userLng = parseFloat(localStorage.getItem('userLng'));

  const approxLocation = JSON.parse(localStorage.getItem('userApproxLocation') || '{}');
console.table(
  data.vendors.map(v => ({
    id: v.vendorId,
    name: v.bsaleConfig?.office?.officeData?.name,
    lat: v.bsaleConfig?.office?.officeData?.latitude,
    lng: v.bsaleConfig?.office?.officeData?.longitude
  }))
);

console.log("📍 Ubicación usuario:", userLat, userLng);




  const vendedoresConDistancia = data.vendors.map(v => {
  const office = v.bsaleConfig?.office?.officeData;

  // default
  v.distanceKm = null;

  if (!office?.latitude || !office?.longitude) {
    return v;
  }

  const lat = Number(office.latitude);
  const lng = Number(office.longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return v;
  }

  if (!Number.isFinite(userLat) || !Number.isFinite(userLng)) {
    console.warn("Ubicación del usuario no disponible aún");
    return v;
  }

  // 🔥 AQUÍ estaba el error: faltaba calcularla
  v.distanceKm = distanciaKm(userLat, userLng, lat, lng);

  return v;
});


console.table(
  data.vendors.map(v => ({
    id: v.vendorId,
    name: v.bsaleConfig?.office?.officeData?.name, 
    lat: v.bsaleConfig?.office?.officeData?.latitude,
    lng: v.bsaleConfig?.office?.officeData?.longitude
  }))
);




  const vendedoresConDistanciaOrdenados = vendedoresConDistancia
  .filter(v => v.distanceKm !== null) // descarta los que no tienen lat/lng
  .sort((a, b) => a.distanceKm - b.distanceKm);

  if (!vendedoresConDistanciaOrdenados.length) {
  console.error("❌ No hay vendedores con distancia válida");
  return;
}

  const vendedorMasCercano = vendedoresConDistanciaOrdenados[0];
console.log("El vendedor más cercano es:", vendedorMasCercano.vendorId, vendedorMasCercano.distanceKm, "km");
localStorage.setItem("closestVendor", JSON.stringify(vendedorMasCercano));

// Guardar vendorId y su inventario
localStorage.setItem("currentVendorId", vendedorMasCercano.vendorId);
retryPendingAddToCart();

await loadVendorInventory(vendedorMasCercano.vendorId);


// Guardar cookie accesible para Shopify Liquid
document.cookie = `vendor_id=${vendedorMasCercano.vendorId}; path=/; max-age=31536000; SameSite=Lax; Secure`;
document.cookie = `inventory=${encodeURIComponent(JSON.stringify(vendedorMasCercano.inventory))}; path=/; domain=.masca.cl; max-age=31536000; SameSite=Lax; Secure`;





const closestVendor = JSON.parse(localStorage.getItem("closestVendor"));
console.log("Vendor más cercano almacenado:", closestVendor);


  console.log("Vendedores con distancia:", vendedoresConDistancia);
  return vendedoresConDistancia;
}

getVendors();


function retryPendingAddToCart() {
  const pending = JSON.parse(
    localStorage.getItem("pendingAddToCart") || "null"
  );

  if (!pending) return;

  const vendorId = localStorage.getItem("currentVendorId");
  if (!vendorId) return;

  console.log("🔁 Reintentando add to cart:", pending);

  const cart = JSON.parse(localStorage.getItem("externalCart")) || {
    customer: {},
    items: []
  };

  const existing = cart.items.find(i => i.sku === pending.sku);

  if (existing) {
    existing.qty += pending.qty;
  } else {
    cart.items.push({
      ...pending,
      vendorId
    });
  }

  localStorage.setItem("externalCart", JSON.stringify(cart));
  localStorage.removeItem("pendingAddToCart");

  // abrir carrito
  document.getElementById("external-cart-drawer")
    ?.classList.remove("hidden");

  console.log("✅ Producto agregado tras seleccionar vendor");
}



function distanciaKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radio de la tierra en km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;

  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}


async function loadVendorInventory(vendorId) {
  const res = await fetch(
    `https://us-central1-masca-51862.cloudfunctions.net/api/shopify/inventory?vendorId=${vendorId}`
  );

  if (!res.ok) {
    console.error("❌ Error cargando inventario");
    return null;
  }

  const data = await res.json();
  console.log("📦 Inventario recibido del vendor:", vendorId, data.inventory);

  localStorage.setItem("vendorInventory", JSON.stringify(data.inventory));

window.vendorInventory = data.inventory;

// 🔔 AVISAR AL FRONT QUE YA HAY INVENTARIO
document.dispatchEvent(
  new CustomEvent("vendor:inventoryReady", {
    detail: data.inventory
  })
);

console.log("✅ vendor:inventoryReady disparado", Object.keys(data.inventory).length);


  // cookie opcional si la necesitas en Liquid
  document.cookie = `vendor_inventory=${encodeURIComponent(
    JSON.stringify(data.inventory)
  )}; path=/; max-age=3600; SameSite=Lax; Secure`;

  return data.inventory;
}


document.addEventListener("DOMContentLoaded", () => {
  const vendorId = localStorage.getItem("currentVendorId");

  if (!vendorId) {
    console.warn("⚠️ vendorId no disponible aún");
    return;
  }

  document
    .querySelectorAll("[data-add-to-external-cart]")
    .forEach(btn => {
      btn.dataset.vendorId = vendorId;
    });
});


console.log("📌 LocalStorage closestVendor:", localStorage.getItem("closestVendor"));
console.log("📌 LocalStorage vendorInventory:", localStorage.getItem("vendorInventory"));
